import React from 'react';
import { Affix } from 'antd';
export default function Nav(_ref) {
  var {
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(Affix, {
    className: "toc-affix",
    offsetTop: 16
  }, /*#__PURE__*/React.createElement("div", null, children));
}